import React from 'react';

import RufsError from '../../../errors/rufsError.jsx';

const PaymentError = () => (
    <RufsError>
        Vi får ikke til å sende din godkjenning akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default PaymentError;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/errors/acceptAgreementError.jsx